<button
  type="button"
  [ngClass]="hostButtonClass()"
  class="p-3 text-left w-full"
  [attr.aria-label]="ariaLabel() ?? null"
  (click)="emitClick($event)"
  (keydown)="emitKeyEnter($event)"
  [disabled]="disabled()"
>
  <div class="flex flex-col w-full">
    <ng-content></ng-content>
  </div>
</button>
